import React from "react";
import { PHOTO_URL } from "../../base";
import { ClearIcon } from "./ProjectIcons";

type ThumbnailModalProps = {
  thumbnailUrl: string;
  onClose: () => void;
};

const ThumbnailModal = ({ thumbnailUrl, onClose }: ThumbnailModalProps) => {
  const photoUrl = PHOTO_URL || "favicon.html";
  // Get timestamp from localStorage to prevent caching
  const thumbnailUpdateTimestamp =
    localStorage.getItem("thumbnail_last_updated") || Date.now().toString();
  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-4 rounded shadow-lg relative max-w-[60vw] max-h-[60vh] flex flex-col items-center justify-center">
        <button
          className="absolute top-2 right-2 text-black bg-white"
          onClick={onClose}
        >
          <ClearIcon />
        </button>
        <img
          src={`${photoUrl}${thumbnailUrl}?t=${thumbnailUpdateTimestamp}`}
          alt="Thumbnail"
          className="w-full h-full object-contain"
        />
      </div>
    </div>
  );
};

export default ThumbnailModal;
